import { ModalFooterProps } from "./types";

export default function ModalFooter({ children }: Readonly<ModalFooterProps>) {
	return (
		<div className="flex flex-row gap-4 md:justify-end justify-center flex-wrap modal-footer">
			{children}
		</div>
	);
}
